module.exports = __webpack_public_path__ + "media/hyper/images/payments/stripe-e42447630de13281fd99687a918f9bb3.png";